module.exports = __webpack_public_path__ + "static/services-img13-2d47cf4b07b904ee4571db7576b430bf.png";